import _symbolConstructorDetection from "../internals/symbol-constructor-detection";
var exports = {};
var NATIVE_SYMBOL = _symbolConstructorDetection;

/* eslint-disable es/no-symbol -- safe */
exports = NATIVE_SYMBOL && !!Symbol["for"] && !!Symbol.keyFor;
export default exports;